import { ImportExportOutlined } from "@material-ui/icons";
import { EldImportList } from "./EldImportList";
import { EldImportCreate } from "./EldImportCreate";
import { EldImportFinish } from "./EldImportFinish";

export default {
  icon: ImportExportOutlined,
  list: EldImportList,
  create: EldImportCreate,
  edit: EldImportFinish,
};
